import React from 'react';
import AppContainer from './containers/appContainer'

function App() {

  return (
    <AppContainer />
  );

}

export default App;
